import axios from "axios";
import { saveAs } from "file-saver";
import Response from "../response";
import { errCodes } from "../response/errors";
import { COMMISSIONS_API_BASE_URL } from "../../utils/constants";

class CommissionsService {
  constructor() {
    this.baseUrl = COMMISSIONS_API_BASE_URL;
    this.endpoint = "commissions";

    this.url = `${this.baseUrl}/${this.endpoint}`;

  }

  async retrieveCarrierFilesTree(fileDir) {
    try {
      const formData = new FormData();
      formData.append("file_dir", fileDir);

      const response = await axios({
        url: `${this.url}/retrieve-carrier-files-tree`,
        method: "POST",
        data: formData
      })

      return Response.create(response.data, true);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async processCommissionFile(file, carrier, organization, userID) {
    try {
      const formData = new FormData();
      formData.append("raw_file", file);
      formData.append("carrier_id", carrier.id);
      formData.append("carrier_name", carrier.label)
      formData.append("org_id", organization.id);
      formData.append("user_id", userID);

      const response = await axios({
        url: `${this.url}/process-commission-file`,
        method: "POST",
        data: formData,
        responseType: "blob",
      });

      const originalFileName = file.name;
      const lastDotIndex = originalFileName.lastIndexOf(".");
      const filename =
        lastDotIndex !== -1
          ? originalFileName.slice(0, lastDotIndex) + ".xlsx"
          : originalFileName + ".xlsx";

      saveAs(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
      );

      return Response.create({}, true);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }
}

export default CommissionsService;
